import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import PhoneIcon from '@material-ui/icons/Phone';
import FavoriteIcon from '@material-ui/icons/Favorite';
import PersonPinIcon from '@material-ui/icons/PersonPin';
import HelpIcon from '@material-ui/icons/Help';
import ShoppingBasket from '@material-ui/icons/ShoppingBasket';
import ThumbDown from '@material-ui/icons/ThumbDown';
import ThumbUp from '@material-ui/icons/ThumbUp';
import Typography from '@material-ui/core/Typography';
import JourneyStageInsights from './JourneyStageInsights';
import HighLightIcon from '@material-ui/icons/AddAlert';
import JourneyStageInsightsResearch from './JourneyStageInsightsResearch';
import JourneyStageInsightsCustomer from './JourneyStageInsightsCustomer';

function TabContainer(props) {
    return (
        <Typography component="div" style={{ padding: 8 * 3 }}>
            {props.children}
        </Typography>
    );
}

TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
};

const styles = theme => ({
    root: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
    appbar: {
        backgroundColor: theme.palette.background.paper
        //display: 'none'
    },
    heading: {
        fontSize: theme.typography.pxToRem(18),
        fontWeight: theme.typography.fontWeightRegular,
        paddingLeft: 10
    }
});

class JourneyInsights extends React.Component {
    state = {
        value: 0,
    };

    handleChange = (event, value) => {
        this.setState({ value });
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.currentTab !== undefined) {
            return {
                value: nextProps.currentTab
            }
        }
        return null;
    }

    render() {
        const { classes } = this.props;
        const { value } = this.state;

        return (
            <div className={classes.root}>
                <Typography className={classes.heading}>
                    <HighLightIcon />&nbsp;Journey insights
                </Typography>
                <br />
                <AppBar position="static" className={classes.appbar}>
                    <Tabs
                        value={value}
                        onChange={this.handleChange}
                        indicatorColor="primary"
                        textColor="primary"
                        scrollable
                        scrollButtons="auto">
                        <Tab label="Awareness" />
                        <Tab label="Research" />
                        <Tab label="Customer" />
                        <Tab label="Brand Advocates" />
                    </Tabs>
                </AppBar>
                {value === 0 && <TabContainer><JourneyStageInsights /></TabContainer>}
                {value === 1 && <TabContainer><JourneyStageInsightsResearch /></TabContainer>}
                {value === 2 && <TabContainer><JourneyStageInsightsCustomer /></TabContainer>}
                {value === 3 && <TabContainer>Nothing to see here yet :)</TabContainer>}
            </div>
        );
    }
}

JourneyInsights.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(JourneyInsights);




// WEBPACK FOOTER //
// ./src/components/JourneyInsights.js